import { text } from "@quickpoint.me/shared";
import { useRecoilState, useRecoilValue } from "recoil";
import {
	AiChatLevelAtom,
	InlineEditTargetAtom,
	type AiChatLevel,
} from "../../state/aiChatAtoms";
import { LocaleAtom } from "../../state/localeAtom";
import { Tab, TabList } from "./styled/ChatStyled";

const levels: { id: AiChatLevel; tabId: string; panelId: string; labelKey: "tabChat" | "tabEditElement" | "tabStructure" }[] = [
	{ id: 1, tabId: "tab-chat", panelId: "panel-chat", labelKey: "tabChat" },
	{ id: 2, tabId: "tab-edit-element", panelId: "panel-edit", labelKey: "tabEditElement" },
	{ id: 3, tabId: "tab-structure", panelId: "panel-code", labelKey: "tabStructure" },
];

function ChatLevelSwitcher() {
	const [activeLevel, setActiveLevel] = useRecoilState(AiChatLevelAtom);
	const inlineTarget = useRecoilValue(InlineEditTargetAtom);
	const level2Disabled = !inlineTarget;
	useRecoilValue(LocaleAtom); // re-render on locale change

	const handleKeyDown = (e: React.KeyboardEvent) => {
		const currentIndex = levels.findIndex((l) => l.id === activeLevel);
		let nextIndex = currentIndex;

		if (e.key === "ArrowRight") {
			e.preventDefault();
			nextIndex = (currentIndex + 1) % levels.length;
		} else if (e.key === "ArrowLeft") {
			e.preventDefault();
			nextIndex = (currentIndex - 1 + levels.length) % levels.length;
		} else {
			return;
		}

		const nextLevel = levels[nextIndex];
		if (nextLevel.id === 2 && level2Disabled) {
			// Skip disabled tab
			nextIndex =
				e.key === "ArrowRight"
					? (nextIndex + 1) % levels.length
					: (nextIndex - 1 + levels.length) % levels.length;
		}
		setActiveLevel(levels[nextIndex].id);
	};

	return (
		<TabList role="tablist" aria-label={text.chat.editingMode}>
			{levels.map((level) => {
				const isActive = activeLevel === level.id;
				const isDisabled = level.id === 2 && level2Disabled;

				return (
					<Tab
						key={level.id}
						role="tab"
						id={level.tabId}
						aria-selected={isActive}
						aria-controls={level.panelId}
						aria-disabled={isDisabled || undefined}
						$active={isActive}
						$disabled={isDisabled}
						tabIndex={isActive ? 0 : -1}
						onClick={() => {
							if (!isDisabled) setActiveLevel(level.id);
						}}
						onKeyDown={handleKeyDown}
					>
						{text.chat[level.labelKey]}
					</Tab>
				);
			})}
		</TabList>
	);
}

export default ChatLevelSwitcher;
